import { useState } from 'react';
import type { FaqItem } from '@/mocks/navigation';

interface FaqSectionProps {
  items: FaqItem[];
  id?: string;
  heading?: string;
  subheading?: string;
}

export default function FaqSection({
  items,
  id = 'faq',
  heading = '常见问题',
  subheading = '关于收录标准、更新频率与使用方式，这里集中回答。',
}: FaqSectionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id={id} aria-labelledby={`${id}-title`} className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20 bg-background-100">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
        <div className="lg:col-span-4">
          <span className="font-label text-xs tracking-[0.2em] text-primary-600">FAQ</span>
          <h2 id={`${id}-title`} className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            {heading}
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">{subheading}</p>
          <div className="mt-6 hidden lg:flex items-center gap-2 font-label text-xs text-foreground-500">
            <i className="ri-information-line text-accent-600" aria-hidden="true"></i>
            未解决的问题可通过联系方式反馈
          </div>
        </div>

        <div className="lg:col-span-8">
          <dl className="space-y-3">
            {items.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={item.q}
                  className="rounded-lg border border-background-200 bg-background-50 overflow-hidden"
                >
                  <dt>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left"
                    >
                      <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                        {item.q}
                      </h3>
                      <span className="w-6 h-6 shrink-0 flex items-center justify-center text-lg text-primary-500">
                        <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} aria-hidden="true"></i>
                      </span>
                    </button>
                  </dt>
                  {isOpen && (
                    <dd className="px-4 md:px-5 pb-4 -mt-1 text-sm leading-relaxed text-foreground-600">
                      {item.a}
                    </dd>
                  )}
                </div>
              );
            })}
          </dl>
        </div>
      </div>
    </section>
  );
}